import {
  AllWeeklyCheckInTableData,
  isWeeklyCheckInRowUser,
  UserWeeklyCheckInTableRowData,
  WeeklyCheckInRegradeData,
  WeeklyCheckInTableRowData,
} from "./types";

export const updateUserWeeklyCheckInTableData = (
  array: WeeklyCheckInTableRowData[],
  updatedData: WeeklyCheckInRegradeData,
  threadId: string
) =>
  array.map((entry) => {
    if (isWeeklyCheckInRowUser(entry) && entry.threadId === threadId) {
      return {
        ...entry,
        ...updatedData,
      };
    }
    return entry;
  });

/**
 * Applies a regrade to the thread's row in every loaded time interval, so the
 * table stays current whichever interval the user is viewing.
 */
export const updateRegradedCheckInInAllIntervals = (
  allData: AllWeeklyCheckInTableData,
  updatedData: WeeklyCheckInRegradeData,
  threadId: string
): AllWeeklyCheckInTableData =>
  Object.fromEntries(
    Object.entries(allData).map(([timeInterval, byEntityType]) => {
      const userRows = byEntityType?.user;
      if (!byEntityType || !userRows) return [timeInterval, byEntityType];
      return [
        timeInterval,
        {
          ...byEntityType,
          user: updateUserWeeklyCheckInTableData(
            userRows,
            updatedData,
            threadId
          ),
        },
      ];
    })
  );

/** Finds a user's check-in row by thread in whichever time interval has it loaded. */
export const findCheckInRowByThread = (
  allData: AllWeeklyCheckInTableData | undefined,
  threadId: string | undefined
): UserWeeklyCheckInTableRowData | undefined => {
  if (!allData || !threadId) return undefined;
  for (const byEntityType of Object.values(allData)) {
    const row = byEntityType?.user?.find(
      (checkIn) =>
        isWeeklyCheckInRowUser(checkIn) && checkIn.threadId === threadId
    );
    if (row) return row as UserWeeklyCheckInTableRowData;
  }
  return undefined;
};
